import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import slots from "../data/slots.json";
import "../css/SlotDetail.css";

const SlotDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const slot = slots.find((s) => s.id === id);
  const [showModal, setShowModal] = useState(false);

  if (!slot) return <div className="not-found">台が見つかりませんでした。</div>;

  return (
    <div className="slot-detail-container">
      <h1 className="slot-title">{slot.name}</h1>
      <div className="slot-image-area">
        <img src={slot.imageUrl} alt={slot.name} className="slot-image" />
      </div>

      <div className="slot-info">
        <p className="slot-manufacturer">メーカー：{slot.manufacturer}</p>
        <div className="slot-link">
          <a
            href={`http://www.x.com/${slot.account}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src="/images/x.png" class="x-account" alt="x-account" />
            {slot.manufacturer}
          </a>
          {slot.link ? (
            slot.link.map((item, index) => (
              <a href={item.link} target="_blank" rel="noreferrer">
                <img src={item.imageUrl} alt={item.name} />
                {item.name}
              </a>
            ))
          ) : (
            <></>
          )}
        </div>
        {/* <p
          className="slot-description"
          dangerouslySetInnerHTML={{ __html: slot.description }}
        ></p> */}
        <div className="slot-spec-card">
          <h2>スペック</h2>
          <div
            className="slot-spec-area"
            dangerouslySetInnerHTML={{ __html: slot.spec }}
          ></div>
        </div>
        {/* 🎰 リール配列 */}
        <div className="slot-spec-card">
          <h2>🎰 リール配列</h2>
          <div
            className="reel-image-area"
            onClick={() => setShowModal(true)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={slot.reelImage || "/images/magical-reel.png"}
              alt="リール配列"
              className="reel-image"
            />
          </div>
        </div>
        {/* 🍒 子役表 */}
        <div className="slot-spec-card">
          <h2>🍒 子役表</h2>
          <table className="payout-table">
            <thead>
              <tr>
                <th>役</th>
                <th>払出</th>
              </tr>
            </thead>
            <tbody>
              {slot.payouts ? (
                slot.payouts.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <img src={item.name} alt="" />
                    </td>
                    <td dangerouslySetInnerHTML={{ __html: item.rate }}></td>
                  </tr>
                ))
              ) : (
                <>
                  <tr>
                    <td>調査中</td>
                    <td>調査中</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        {/* 🏠 HOMEに戻るボタン */}
        <button className="back-home-btn" onClick={() => navigate("/")}>
          ⬅ HOMEに戻る
        </button>{" "}
      </div>

      {/* 📸 モーダル */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={slot.reelImage || "/images/sample_reel.png"}
              alt="リール配列"
              className="modal-image"
            />
            <button className="close-btn" onClick={() => setShowModal(false)}>
              ✕ 閉じる
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SlotDetail;
